import { swRequest } from "./sw-request.js";

// There are other tag methods not currently brought into the svelte
// fold.  This is sufficient for creating an API store though.

// TODO: associate, create, delete, modify

export const getTags = () =>
  swRequest({
    path: "/api/tags/get_all",
  });
